<div class="title">Graffiti</div>
<div class="option">
    <span>Size</span>
    <input [value]="size()" (input)="update($event.target.valueAsNumber)" type="number" id="size" name="size" [min]="min" [max]="max" step="1">
</div>
